"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondaryButtons = void 0;
exports.secondaryButtons = [
    {
        props: { variant: 'secondaryDefault' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.secondary.main,
                border: "1px solid ".concat(theme.palette.secondary.main),
                '&:hover': {
                    backgroundColor: theme.palette.secondary.light,
                },
                '&:focus': {
                    backgroundColor: theme.palette.secondary.light,
                },
                '&:active': {
                    color: theme.palette.text.light,
                    backgroundColor: theme.palette.secondary.dark,
                    border: "1px solid ".concat(theme.palette.secondary.dark),
                },
                '&:disabled': {
                    backgroundColor: theme.palette.neutrals.white,
                    color: theme.palette.text.disabled,
                    border: "1px solid ".concat(theme.palette.text.disabled),
                },
            });
        },
    },
    {
        props: { variant: 'secondaryHC' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.text.light,
                border: "1px solid ".concat(theme.palette.neutrals.white),
                '&:hover': {
                    color: theme.palette.text.interactive,
                    backgroundColor: theme.palette.primary.light,
                    border: "1px solid ".concat(theme.palette.secondary.light),
                },
                '&:focus': {
                    color: theme.palette.text.interactive,
                    backgroundColor: theme.palette.primary.light,
                    border: "1px solid ".concat(theme.palette.secondary.light),
                },
                '&:active': {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.neutrals.primary,
                    border: "1px solid ".concat(theme.palette.neutrals.white),
                },
                '&:disabled': {
                    color: theme.palette.text.disabled,
                    border: "1px solid ".concat(theme.palette.text.disabled),
                },
            });
        },
    },
];
